// Mock data for Yesenia's House Cleaning LLC

export const services = [
  {
    id: 1,
    title: "House Cleaning",
    description: "Professional residential cleaning services to keep your home spotless and healthy. From regular maintenance to one-time deep cleans.",
    features: ["Kitchen & Bathroom Deep Clean", "Dusting & Vacuuming", "Floor Mopping", "Window Cleaning"],
    image: "/img1.jpg",
    icon: "home"
  },
  {
    id: 2,
    title: "Office Cleaning",
    description: "Keep your workplace pristine and professional with our comprehensive commercial cleaning solutions tailored to your business needs.",
    features: ["Desk & Surface Sanitization", "Restroom Deep Cleaning", "Floor Care", "Trash Removal"],
    image: "/img2.jpg",
    icon: "building"
  },
  {
    id: 3,
    title: "Construction Cleaning",
    description: "Post-construction cleanup services to remove debris, dust, and prepare your space for occupancy with meticulous attention to detail.",
    features: ["Debris Removal", "Dust & Residue Cleaning", "Window & Surface Polishing", "Final Touch-ups"],
    image: "/img6.jpg",
    icon: "hardHat"
  },
  {
    id: 4,
    title: "Deep Cleaning",
    description: "Intensive cleaning service that goes beyond the surface, targeting every corner and hard-to-reach area for a truly immaculate space.",
    features: ["Carpet & Upholstery Cleaning", "Appliance Deep Clean", "Grout & Tile Scrubbing", "Baseboard & Vent Cleaning"],
    image: "/img7.jpg",
    icon: "sparkles"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Homeowner",
    content: "Yesenia's team transformed our home! Their attention to detail is incredible. They use safe products which is perfect for our kids and pets. Highly recommend!",
    rating: 5,
    location: "Flagstaff, AZ"
  },
  {
    id: 2,
    name: "Michael Rodriguez",
    role: "Office Manager",
    content: "We've been using their office cleaning services for over a year. Professional, reliable, and thorough. Our office has never looked better!",
    rating: 5,
    location: "Flagstaff, AZ"
  },
  {
    id: 3,
    name: "Jennifer Adams",
    role: "Property Manager",
    content: "Their post-construction cleaning is top-notch. They made our new building move-in ready ahead of schedule. Exceptional service and great communication.",
    rating: 5,
    location: "Flagstaff, AZ"
  },
  {
    id: 4,
    name: "David Chen",
    role: "Homeowner",
    content: "The deep cleaning service exceeded our expectations. Every corner of our home is spotless. Worth every penny and then some!",
    rating: 5,
    location: "Flagstaff, AZ"
  }
];

export const companyInfo = {
  name: "Yesenia's House Cleaning LLC",
  tagline: "Professional Cleaning Services You Can Trust",
  phone: "(928) 286-7467",
  email: "Yeseniabeltrancleaning@gmail.com",
  address: "Flagstaff, Arizona",
  yearsOfExperience: 7,
  serviceArea: "Flagstaff, Arizona and surrounding areas",
  features: [
    {
      title: "7 Years of Excellence",
      description: "Trusted by hundreds of satisfied customers in Flagstaff"
    },
    {
      title: "100% Safe Products",
      description: "We use only safe, effective products designed for proper sanitization"
    },
    {
      title: "Satisfaction Guarantee",
      description: "We're not happy until you're happy. 100% satisfaction guaranteed"
    },
    {
      title: "Local & Reliable",
      description: "Proudly serving the Flagstaff community with dependable service"
    }
  ]
};

export const faqs = [
  {
    id: 1,
    question: "What areas do you serve?",
    answer: "We proudly serve Flagstaff, Arizona and the surrounding areas. Contact us to confirm service availability in your specific location."
  },
  {
    id: 2,
    question: "Are your cleaning products safe?",
    answer: "Absolutely! We use 100% safe products specifically designed for effective sanitization. They're safe for children, pets, and the environment."
  },
  {
    id: 3,
    question: "Do you offer one-time cleaning services?",
    answer: "Yes! We offer both one-time deep cleaning services and recurring maintenance plans. Choose what works best for your needs."
  },
  {
    id: 4,
    question: "How do I get a quote?",
    answer: "Simply fill out our quote request form on this page or give us a call. We'll provide a free, no-obligation quote based on your specific needs."
  },
  {
    id: 5,
    question: "What if I'm not satisfied with the service?",
    answer: "We stand behind our work with a 100% satisfaction guarantee. If you're not completely happy, we'll make it right at no additional cost."
  }
];